import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { TRIM_TOOL } from '@constants/trim-tool';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import { getAppropriateUrl } from '@invideoio/web-shared/utils/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { WhyToUseSection } from '../../types/landing-page';
import Feature from './Feature';
import Title from './Title';

interface FeatureProps {
  featureSection: WhyToUseSection;
  platform: PlatformType;
  browser: BrowserType;
}

function FeatureSection(props: FeatureProps) {
  const { whys } = TRIM_TOOL.WHYs;
  const { platform, featureSection, browser } = props;
  const { plainHeading, highlightedHeading, WhyToUseItems, sectionImage } =
    featureSection;

  const imageUrl = getAppropriateUrl(sectionImage.url, browser, platform);
  return (
    <section
      className={ivclass(
        'sm:iv-pt-80 md:iv-pt-64 lg:iv-pt-150 xl:iv-pt-150',
        'iv-px-20',
      )}
    >
      <div className={ivclass('xl:iv-container', 'iv-mx-auto')}>
        <div className={ivclass('xl:iv-pb-20')}>
          <Title
            plainTitle={plainHeading}
            highlightedTitle={highlightedHeading}
          />
        </div>
        <div
          className={ivclass(
            'iv-grid',
            'iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12',
            'lg:iv-gap-40 xl:iv-gap-40',
          )}
        >
          <div
            className={ivclass(
              'iv-relative',
              'iv-col-span-4 md:iv-col-span-8 lg:iv-col-start-2 lg:iv-col-end-7 xl:iv-col-start-2 xl:iv-col-end-7',
            )}
          >
            <div
              className={ivclass(
                'lg:iv-sticky xl:iv-sticky',
                'lg:iv-top-20 xl:iv-top-20',
                'md:iv-mx-[-25px] md:iv-overflow-x-hidden',
              )}
            >
              <div
                className={ivclass(
                  'iv-relative',
                  'iv-h-[283px] md:iv-h-[445.5px] lg:iv-h-[561px] xl:iv-h-[561px]',
                  'iv-w-full',
                  'sm:iv-mb-64 md:iv-mb-50 lg:iv-mb-64 xl:iv-mb-64',
                  'sm:iv-mt-35 iv-mt-50',
                  'iv-mx-auto',
                )}
              >
                <div className={ivclass('iv-feature-img')}>
                  <div
                    className={ivclass('iv-relative', 'iv-w-full iv-h-full')}
                  >
                    <ImageComponent
                      elementype="native"
                      src={imageUrl}
                      alt={sectionImage.alternativeText}
                      className="iv-object-contain"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={ivclass(
              'iv-col-span-4 md:iv-col-start-2 md:iv-col-end-8 lg:iv-col-span-6 xl:iv-col-span-6',
              'lg:iv-pt-30 xl:iv-pt-40',
            )}
          >
            {WhyToUseItems.map((why: any, idx: number) => {
              const whyImage = whys[idx]?.image;
              return (
                <Feature
                  key={idx}
                  image={whyImage}
                  idx={idx}
                  title={why.title}
                  highlightedContent={why.highlightedDescription}
                  plainContent={why.plainDescription}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;
